export const defaultAllowList = {
    // required parameters
    client_id: true,
    created: true,
    event_id: true,
    event_name: true,
    // parameters included by Analytics.js
    action_name: true,
    analytics_ua: true,
    arb_id: true,
    cid: true,
    domain: true,
    event_count: true,
    flags: true,
    link_name: true,
    lsid: true,
    merchant_id: true,
    modal_name: true,
    // `page` is redacted because it includes the query portion of the URL, which often contains PII (e.g. /search?query=kyeb@example.com)
    page: false,
    page_view_id: true,
    privacy_consent_loaded: true,
    privacy_consent_functional: true,
    privacy_consent_advertising: true,
    referrer: true,
    sid: true,
    stripe_locale: true,
    // user environment params
    ua_browser_name: true,
    ua_browser_version: true,
    ua_device_model: true,
    ua_device_type: true,
    ua_device_vendor: true,
    ua_engine_name: true,
    ua_engine_version: true,
    ua_mobile: true,
    ua_model: true,
    ua_os_name: true,
    ua_os_version: true,
    ua_platform: true,
    ua_platform_version: true,
    user_id: true,
    version: true,
    viewed_name: true,
    viewport_height: true,
    viewport_width: true
};

//# sourceMappingURL=defaultAllowList.js.map